export const appRoutes: Record<string, string> = {
  login: '/login',
  loginMsal: './login-msal',
  dashboard: '/panel/dashboard',
  formGenerator: '/form-generator',
};
